import { range } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import infiniteLoading from 'vue-infinite-loading';
import accountSocialAvatar from '@/components/account/account-social-avatar/account-social-avatar.vue';
import userDetailsMixin from '@/mixins/userDetails';
import socialLevelMixin from '@/mixins/socialLevel';
import { MODALS } from '@/components/app/app-modals/modals-constants';


export default {
  mixins: [
    userDetailsMixin,
    socialLevelMixin,
  ],
  components: {
    accountSocialAvatar,
    infiniteLoading,
  },
  data() {
    return {
      infiniteLoader: null,
      isLoading: false,
    };
  },
  watch: {
    isLoggedIn: {
      handler: 'leaderboardsParamChangeHandler',
    },
    leaderboardsDateRange: {
      handler: 'leaderboardsParamChangeHandler',
    },
    selectedLeaderboard: {
      handler: 'leaderboardsParamChangeHandler',
      immediate: true,
    },
    rows() {
      if (this.infiniteLoader) {
        this.infiniteLoader.loaded();
        if (!this.leaderboardsResults.canLoadMore) {
          this.infiniteLoader.complete();
        }
      }
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('leaderboards', ['selectedLeaderboard']),
    ...mapState('leaderboards', [
      'leaderboardsDateRange',
      'leaderboardsResults',
    ]),
    rows() {
      const items = this.leaderboardsResults.data === null ? [] : this.leaderboardsResults.data;
      if (this.leaderboardsResults.trader) {
        return [
          this.leaderboardsResults.trader,
          ...items.filter(i => i.userName !== this.leaderboardsResults.trader.userName),
        ];
      }
      return items;
    },
    infiniteLoadingKey() {
      return `${this.selectedLeaderboard.leaderBoardId}-${this.leaderboardsDateRange}-${this.isLoggedIn.toString()}`;
    },
    showNoDataMessage() {
      return !this.isLoading && this.rows.length === 0;
    },
  },
  methods: {
    ...mapActions('leaderboards', ['resetLeaderboardsResults', 'getLeaderboardsResults']),
    ...mapActions('popup', ['setCurrentSmallPopup']),
    range(limit) {
      return range(0, limit);
    },
    goInfinite(infi) {
      this.infiniteLoader = infi;

      if (this.leaderboardsResults.canLoadMore) {
        this.loadLeaderboardRows();
      }
    },
    loadLeaderboardRows() {
      this.isLoading = true;
      this.getLeaderboardsResults()
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.infiniteLoader.complete();
          this.infiniteLoader = null;
        });
    },
    leaderboardsParamChangeHandler(newValue) {
      if (newValue) {
        this.resetLeaderboardsResults();
        this.infiniteLoader = null;
      }
    },
    traderLevelColor(item) {
      return this.getLevelByNumber(item.traderLevel).currentColor;
    },
    traderLevelDisplay(item) {
      const level = this.getLevelByNumber(item.traderLevel);
      return `Level ${level.num} (${level.text})`;
    },
    traderRoiDisplay(item) {
      const value = Math.abs(item.roi * 100);
      const fractionDigits = (value >= 1000) ? 0 : 1;
      const roi = value.toLocaleString('en-US', {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
      });
      return `${roi}%`;
    },
    isItemCurrentUser(item) {
      return this.leaderboardsResults.trader
        && this.leaderboardsResults.trader.userName === item.userName;
    },
    rowClassModifiers(item) {
      return {
        'leaderboards-table__row': true,
        'leaderboards-table__row--me': this.isItemCurrentUser(item),
      };
    },
    roiModifiers(item) {
      return {
        'leaderboards-table__row-roi': true,
        'leaderboards-table__row-roi--gain': item.roi > 0,
        'leaderboards-table__row-roi--loss': item.roi < 0,
      };
    },
    arrowChangeClassModifiers(item) {
      return {
        'leaderboards-table__row-change-arrow': true,
        'leaderboards-table__row-change-arrow--up': item.rankChange > 0,
        'leaderboards-table__row-change-arrow--down': item.rankChange < 0,
      };
    },
    showRankChange(item) {
      return item.rankChange !== null && item.rankChange !== 0;
    },
    onAvatarClick(item) {
      if (this.isItemCurrentUser(item)) return;
      this.showUserDetails(item);
    },
    onRoiInfoClick() {
      this.setCurrentSmallPopup(MODALS.SMALL_ROI_INFO);
    },
    onWinsInfoClick() {
      this.setCurrentSmallPopup(MODALS.SMALL_WINS_INFO);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/leaderboards/leaderboards-table/leaderboards-table.js